import { axiosClientAdmin } from '@/lib/auth';
import { Filter, FilterGroup, FilterOperator, SortOrder } from '@/lib/utils';

export enum EnumProjectMemberType {
  'Unknown' = 'Unknown',
  'MonitoringCompany' = 'MonitoringCompany',
  'Client' = 'Client',
  'Admin' = 'Admin',
  'NVR' = 'NVR',
}

export interface ProjectSearchUserDto {
  id?: string;
  projectId?: string;
  projectName?: string;
  customerId?: string;
  customerName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  alertNotificationsEnabled?: boolean;
  externalId?: string;
  memberType?: EnumProjectMemberType;
}

export interface ProjectUsersSearched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  totalRows?: number;
  rows?: ProjectSearchUserDto[];
}

export interface ProjectCrudded {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  project?: {
    id?: string;
    name?: string;
    // Add other project fields as needed
  };
}

export interface SearchProjectMembersParams {
  customerId: string;
  projectId: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: SortOrder;
  filterOperator?: FilterOperator;
  filterFilters?: Filter[];
  filterFilterGroups?: FilterGroup[];
}

export const searchProjectMembers = async (
  params: SearchProjectMembersParams
): Promise<ProjectUsersSearched> => {
  try {
    const {
      customerId,
      projectId,
      pageNumber,
      pageSize,
      sortBy,
      sortDir,
      filterOperator,
      filterFilters,
      filterFilterGroups,
    } = params;

    const response = await axiosClientAdmin.get<ProjectUsersSearched>(
      `/Customer/${customerId}/project/${projectId}/user/search`,
      {
        params: {
          PageNumber: pageNumber,
          PageSize: pageSize,
          SortBy: sortBy,
          SortDir: sortDir,
          'Filter.Operator': filterOperator,
          'Filter.Filters': filterFilters,
          'Filter.FilterGroups': filterFilterGroups,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error searching project members:', error);
    throw error;
  }
};

export const removeProjectMember = async (
  customerId: string,
  projectId: string,
  userId: string
): Promise<ProjectCrudded> => {
  try {
    const response = await axiosClientAdmin.delete<ProjectCrudded>(
      `/Customer/${customerId}/project/${projectId}/user/${userId}`
    );

    return response.data;
  } catch (error) {
    console.error('Error removing project member:', error);
    throw error;
  }
};

export const postAddProjectMemberCustomer = async (
  customerId: string,
  projectId: string,
  userId: string
): Promise<ProjectCrudded> => {
  console.log('Submit:', customerId, projectId, userId);
  try {
    const response = await axiosClientAdmin.post<ProjectCrudded>(
      `/Customer/${customerId}/project/${projectId}/user/${userId}`
    );

    return response.data;
  } catch (error) {
    console.error('Error adding project member:', error);
    throw error;
  }
};
